export default __webpack_public_path__ + "28470a556d93ed28f9dac0ca79283029.png";